var SearchFiltersDataTestId = /* @__PURE__ */ ((SearchFiltersDataTestId2) => {
  SearchFiltersDataTestId2["SEARCH_FILTERS_TRIGGER"] = "search-filters--trigger";
  SearchFiltersDataTestId2["SEARCH_FILTERS_MODAL"] = "search-filters--modal";
  SearchFiltersDataTestId2["SEARCH_FILTERS_DISTANCE_SLIDER"] = "search-filters--distance-slider";
  SearchFiltersDataTestId2["SEARCH_FILTERS_CLEAR"] = "search-filters--clear";
  SearchFiltersDataTestId2["SEARCH_FILTERS_APPLY"] = "search-filters--apply";
  SearchFiltersDataTestId2["SEARCH_FILTERS_FOOTER_LOADING"] = "search-filters--footer-loading";
  return SearchFiltersDataTestId2;
})(SearchFiltersDataTestId || {});
export {
  SearchFiltersDataTestId
};
